import CadastroConcluido from "assets/images/img-cadastro-concluido.png";
import { HeaderWithBack } from "components/HeaderBack";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import styles from "./styles.module.scss";

export default function SuccessPage() {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	return (
		<div className={styles.container}>
			<HeaderWithBack label="Cadastro enviado" backTo="/perfil" />
			<form className={styles.form}>
				<img
					src={CadastroConcluido}
					alt="Cadastro enviado!"
					className={styles.image}
				/>
				<h2 className={styles.title}>Cadastro enviado!</h2>
				Seu cadastro foi enviado e será avaliado por nossos consultores. Aguarde
				nosso contato.
			</form>
		</div>
	);
}
